import React from 'react';
import Image from 'react-bootstrap/Image';
import finland from '../../../images/finland (2).png';

function FinlandImage() {
    
    return  <Image src={finland} fluid alt="cart-ikon"/>;
    
}
export default FinlandImage;